import * as DialogPrimitive from '@radix-ui/react-dialog'
import type { PropsWithChildren } from 'react'
import { forwardRef } from 'react'

import {
  DialogOverlayStyles,
  DialogBox,
  DialogAligner,
  DialogContentStyles,
} from './Dialog.styled'
import type {
  DialogBoxProps,
  DialogCloseProps,
  DialogContentProps,
  DialogProps,
  DialogTriggerProps,
} from './types'

function Dialog({ children, ...props }: PropsWithChildren<DialogProps>) {
  return (
    <DialogPrimitive.Root {...props}>
      <DialogPrimitive.Overlay css={DialogOverlayStyles} />
      {children}
    </DialogPrimitive.Root>
  )
}

function Content({ children, ...rest }: PropsWithChildren<DialogContentProps>) {
  return (
    <DialogPrimitive.Content css={DialogContentStyles} {...rest}>
      <DialogAligner>{children}</DialogAligner>
    </DialogPrimitive.Content>
  )
}

function Box({
  fullscreen = 'none',
  ...rest
}: PropsWithChildren<DialogBoxProps>) {
  return <DialogBox data-fullscreen={fullscreen} {...rest} />
}

const Trigger = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<DialogTriggerProps>
>(function Trigger({ children, ...rest }, ref) {
  return (
    <DialogPrimitive.Trigger asChild ref={ref} {...rest}>
      {children}
    </DialogPrimitive.Trigger>
  )
})

const Close = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<DialogCloseProps>
>(function Close({ children, ...rest }, ref) {
  return (
    <DialogPrimitive.Close asChild ref={ref} {...rest}>
      {children}
    </DialogPrimitive.Close>
  )
})

function Title({
  children,
  ...rest
}: PropsWithChildren<DialogPrimitive.DialogTitleProps>) {
  return (
    <DialogPrimitive.Title asChild {...rest}>
      {children}
    </DialogPrimitive.Title>
  )
}

function Description({
  children,
  ...rest
}: PropsWithChildren<DialogPrimitive.DialogDescriptionProps>) {
  return (
    <DialogPrimitive.Description asChild {...rest}>
      {children}
    </DialogPrimitive.Description>
  )
}

Dialog.Close = Close
Dialog.Trigger = Trigger
Dialog.Content = Content
Dialog.Box = Box
Dialog.Title = Title
Dialog.Description = Description

export { Dialog }
